/// <amd-module name="Build/Pipelines/Actions/SignalR" />
import { Action } from "Build/Flux/Action";
import { TimelineRecordUpdate } from "Build/Common/Library/Types";

export interface IBuildUpdatedPayload {
    buildId: number;
    definitionId: number;
    definitionScope: string;
}

export interface IStagesUpdatedPayload {
    buildId: number;
    timelineId: string;
    stageUpdates: TimelineRecordUpdate[];
}

export interface ICountData {
    count: number;
    isTruncated: boolean;
}

export interface ISignalRActionCreatorProps {
    actionHub: BuildSignalRActionHub;
}

export class BuildSignalRActionCreator {
    private _actionHub: BuildSignalRActionHub;

    public constructor(options: ISignalRActionCreatorProps) {
        this._actionHub = options.actionHub;
    }

    public buildUpdated(buildId: number, definitionId: number, definitionPath: string) {
        this._actionHub.buildUpdated.invoke({
            buildId: buildId,
            definitionId: definitionId,
            definitionScope: definitionPath
        });
    }

    public stagesUpdated(buildId: number, timelineId: string, stageUpdates: TimelineRecordUpdate[]) {
        this._actionHub.stagesUpdated.invoke({
            buildId: buildId,
            timelineId: timelineId,
            stageUpdates: stageUpdates
        })
    }

    public get actionHub() {
        return this._actionHub;
    }

    public isUserInactive() {
        return this._actionHub.isUserInactive.invoke(undefined);
    }
}

export class BuildSignalRActionHub {
    private _isUserInactive: Action<void>;
    private _buildUpdated: Action<IBuildUpdatedPayload>;
    private _stagesUpdated: Action<IStagesUpdatedPayload>;

    constructor() {
        this._isUserInactive = new Action<void>();
        this._buildUpdated = new Action<IBuildUpdatedPayload>();
        this._stagesUpdated = new Action<IStagesUpdatedPayload>();
    }

    public get buildUpdated() {
        return this._buildUpdated;
    }

    public get isUserInactive() {
        return this._isUserInactive;
    }

    public get stagesUpdated() {
        return this._stagesUpdated;
    }
}